import update from 'immutability-helper';
import { CURRENT_PRODUCT_MODE } from '@utils/constants';
import * as types from './types';
import { SUMMARY_METRICS } from '../constants';

const initialState = {
  loading: true,
  error: false,
  metrics: SUMMARY_METRICS[CURRENT_PRODUCT_MODE],
};

const reducerMap = Object.create(null);

reducerMap[types.FETCHING] = (state) =>
  update(state, {
    $merge: {
      loading: true,
      error: false,
    },
  });

reducerMap[types.FETCHING_SUCCESS] = (state) =>
  update(state, {
    $merge: {
      loading: false,
      error: false,
    },
  });

reducerMap[types.FETCHING_FAILURE] = (state) =>
  update(state, {
    $merge: {
      loading: false,
      error: true,
    },
  });

reducerMap[types.SET_METRICS] = (state, action) =>
  update(state, {
    metrics: {
      $set: action.metrics,
    },
  });

const reducer = (state = initialState, action) =>
  reducerMap[action.type] ? reducerMap[action.type](state, action) : state;

export default reducer;
